import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function ProductCard({ product, index = 0, onQuickAdd }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.6, delay: (index % 4) * 0.08 }}
      data-testid={`product-card-${product.id}`}
    >
      <Link to={`/product/${product.id}`} className="group block">
        <div className="relative overflow-hidden aspect-square bg-white">
          <img src={product.images[0]} alt={product.name}
            className="w-full h-full object-contain transition-transform duration-700 ease-out group-hover:scale-105" />
          <span className="absolute top-4 left-4 font-mono text-[10px] uppercase tracking-[0.2em] bg-ink/80 text-chalk px-3 py-1">
            {product.collection === "pulse" ? "PULSE" : product.collection === "core" ? "CORE" : product.collection === "accessories" ? "Accessories" : product.category}
          </span>
          {onQuickAdd && (
            <button
              onClick={(e) => { e.preventDefault(); e.stopPropagation(); onQuickAdd(); }}
              data-testid={`quick-add-${product.id}`}
              className="absolute top-3 right-3 z-10 bg-ink/85 text-chalk hover:bg-signal hover:text-ink font-mono text-[10px] uppercase tracking-[0.15em] px-3 py-2 transition-colors lg:opacity-0 lg:group-hover:opacity-100">
              + Quick Add
            </button>
          )}
          <div className="absolute inset-x-0 bottom-0 translate-y-full group-hover:translate-y-0 transition-transform duration-300 bg-signal text-ink text-center py-3 font-mono text-xs uppercase tracking-[0.2em]">
            View Product
          </div>
        </div>
        <div className="flex items-start justify-between mt-4">
          <h3 className="font-medium text-base leading-tight">{product.name}</h3>
          <span className="font-mono text-sm text-chalk/90">${product.price.toFixed(0)}</span>
        </div>
        <p className="font-mono text-[11px] text-graphite uppercase tracking-wider mt-1">{product.fit}</p>
        {product.colors?.length > 0 && (
          <div className="flex items-center gap-1.5 mt-2" data-testid={`card-colors-${product.id}`}>
            {product.colors.slice(0, 6).map((c) => (
              <span key={c.name} title={c.name}
                className="w-3 h-3 rounded-full border border-chalk/25 shrink-0"
                style={{ backgroundColor: c.hex }} />
            ))}
            {product.colors.length > 6 && (
              <span className="font-mono text-[10px] text-graphite leading-none">+{product.colors.length - 6}</span>
            )}
          </div>
        )}
      </Link>
    </motion.div>
  );
}
